export { default as getCurrentLang } from './getCurrentLang';
export { default as setContent } from './setContent';
export { default as prepareIncomingData } from './prepareIncomingData';
export { default as getResponsiveParams } from './getResponsiveParams';



// WEBPACK FOOTER //
// ./_HTML/src/js/_utils/index.js